@for (section of config.sections; track section) {
  <section class="model-attribute-sections">
    @if (section.title) {
      <div class="model-attribute-sections__header">
        <p class="model-attribute-sections__header_text">
          {{ section.title }}
        </p>
        @if (section?.statusText) {
          <status
            [config]="{ label: section?.statusText }"
            [status]="section?.statusType || 'info'"
          ></status>
        }
      </div>
    }
    <!-- Handles attribute grid -->
    <section
      [ngClass]="
        'model-attribute-sections__attributes_' +
        (section.attributeFormat || 'responsive-grid')
      "
    >
      @for (item of section.attributes; track item) {
        <model-attribute
          [config]="item"
          [direction]="
            section.attributeFormat === 'two-column-grid' ? 'row_equal' : null
          "
        >
        </model-attribute>
      }
    </section>
  </section>
}
